import { useT } from '@repo/ui/hooks'
import { Input } from '@repo/ui/input'
import { onInput } from '@repo/ui/utils'
import { SearchIcon } from 'lucide-react'
import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

import { selectSearchText } from '@/store/beneficiary-list-filters/selectors'
import { updateSearchTextFilter } from '@/store/beneficiary-list-filters/slice'
import { useStoreDispatch, useStoreState } from '@/store/hooks'

export function BeneficiaryFilterSearchTextWrapper() {
  const dispatch = useStoreDispatch()
  const disabled = useStoreState((state) => state.beneficiaryList.loading)
  const searchText = useSelector(selectSearchText)
  const handleChange = (value: string) => dispatch(updateSearchTextFilter(value))
  return (
    <BeneficiaryFilterSearchText
      disabled={disabled}
      searchText={searchText}
      onChange={handleChange}
    />
  )
}

export function BeneficiaryFilterSearchText({
  disabled,
  searchText,
  onChange,
}: {
  disabled: boolean
  searchText: string
  onChange: (value: string) => void
}) {
  const { t } = useT({ keyPrefix: 'beneficiaryList' })
  const inputRef = useRef<HTMLInputElement>(null)
  useEffect(() => {
    if (disabled) return
    inputRef.current?.focus()
  }, [searchText, disabled])
  return (
    <div className="relative">
      <SearchIcon className="absolute left-2 top-1/2 size-4 -translate-y-1/2 opacity-50" />
      <Input
        ref={inputRef}
        value={searchText}
        onChange={onInput(onChange)}
        placeholder={t('searchTextPlaceholder')}
        className="w-80 pl-8"
        type="search"
        disabled={disabled}
      />
    </div>
  )
}
